import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { TransitionGroup } from 'react-transition-group';

import WidgetHeader from '../Widget/WidgetHeader';
import Overlay from '../Widget/Overlay';
import OverlayPublisher from '../Widget/OverlayPublisher';
import OverlayPartner from '../Widget/OverlayPartner';

import { AutoScalingButtonSet } from '../../components/Buttons/AutoScalingButtonSet';
import { Container, Body, RockTheVoteLabel } from '../DefaultStyles/Details';
import {
    Content,
    Description,
    Details,
    DetailsContainer,
    Footer,
    RTVLogo,
    Title
} from '../DefaultStyles/Shared';
import { isLongText } from '../../components/Shared/commonFunctions';
import AddressPopup from '../../components/FindPollingStation/AddressPopup';
import AnswerButton from '../../components/Assessment/AnswerButton';
import CssTransition from '../../components/Transition/CssTransition';
import ShareDrawer from '../../components/ShareDrawer';
import ToasterAlert from '../../components/Donation/ToasterAlert';
import { RockTheVoteDetails } from '../../components/Shared/rockTheVoteDetails';

import { onShowAddressPopup } from './actions';
import { onBackWithinCard, setOverlayPartnerVisible } from '../Widget/actions';

import { CardTypes } from '../../utils/enums';

const FindPollingStationDetails = props => (
    <Container>
        <Overlay />
        <OverlayPublisher />
        <OverlayPartner
            transitionType="right-to-left"
            logo={RTVLogo}
            name={props.rockTheVoteTitle}
            description={props.rockTheVoteDescription}
        />
        <TransitionGroup>
            {props.addressValidationError && (
                <CssTransition key="alert" in={props.addressValidationError}>
                    <ToasterAlert content={props.addressValidationError} />
                </CssTransition>
            )}
        </TransitionGroup>
        <Body>
            <WidgetHeader />
            <Content isContactAction={false} isSingleAction={true}>
                <Title
                    isLongText={isLongText(props.title, 60)}
                    isExtraLongText={isLongText(props.title, 95)}
                    onClick={e => props.setOverlayPartnerVisible(true, e, false)}
                    dangerouslySetInnerHTML={{
                        __html: props.title
                    }}
                />
                <DetailsContainer>
                    <Details>
                        <Description
                            onClick={e => props.setOverlayPartnerVisible(true, e, false)}
                            isLongText={isLongText(props.subTitle, 90)}
                            isExtraLongText={isLongText(props.subTitle, 160)}
                            dangerouslySetInnerHTML={{
                                __html: props.subTitle
                            }}
                        />
                        <RockTheVoteLabel
                            onClick={e => props.setOverlayPartnerVisible(true, e, true)}
                        >
                            {props.rockTheVoteLabel}
                        </RockTheVoteLabel>
                    </Details>
                </DetailsContainer>
            </Content>
            <AutoScalingButtonSet mobileStyled={true} mobileLeftPosition={8}>
                <AnswerButton
                    text={props.registerButtonText}
                    useLoadingSpinner={false}
                    onClick={() => {
                        props.onShowAddressPopup(true, props.actionIdentifier);
                    }}
                />
            </AutoScalingButtonSet>
            <Footer>
                <ShareDrawer
                    goBack={() =>
                        props.card.type === CardTypes.actionChoice
                            ? props.onBackWithinCard(
                                  props.actionIdentifier,
                                  props.card,
                                  true
                              )
                            : null
                    }
                    fullwidth={props.card.type === CardTypes.actionChoice}
                    rightAlign={props.card.type !== CardTypes.actionChoice}
                    hasBackButton={props.card.type === CardTypes.actionChoice}
                    backgroundColor={'#fff'}
                />
            </Footer>
            <TransitionGroup>
                {props.showAddressPopup && (
                    <CssTransition key="alert" in={props.showAddressPopup}>
                        <AddressPopup
                            onBack={() => {
                                props.onShowAddressPopup(false, props.actionIdentifier);
                            }}
                        />
                    </CssTransition>
                )}
            </TransitionGroup>
            <TransitionGroup>
                {props.findPollingStationError && (
                    <CssTransition key="alert" in={props.findPollingStationError}>
                        <ToasterAlert content={props.findPollingStationError} />
                    </CssTransition>
                )}
            </TransitionGroup>
        </Body>
    </Container>
);

FindPollingStationDetails.propTypes = {
    addressValidationError: PropTypes.any,
    actionIdentifier: PropTypes.string.isRequired,
    card: PropTypes.object.isRequired,
    findPollingStationError: PropTypes.string,
    onBackWithinCard: PropTypes.func.isRequired,
    onShowAddressPopup: PropTypes.func.isRequired,
    registerButtonText: PropTypes.string.isRequired,
    rockTheVoteDescription: PropTypes.string,
    rockTheVoteLabel: PropTypes.string.isRequired,
    rockTheVoteTitle: PropTypes.string,
    setOverlayPartnerVisible: PropTypes.func.isRequired,
    showAddressPopup: PropTypes.bool,
    subTitle: PropTypes.string,
    title: PropTypes.string
};

export default connect(
    state => {
        const defaultTitle =
            'Voting is one of the most powerful tools we have. Make sure you know when and where to vote on Election Day to make your voice heard.';
        const defaultSubtitle =
            'Click below to find your polling station so you can be ready.';
        const defaultButton = 'Find';

        return {
            addressValidationError: state.widget.addressValidationError,
            actionIdentifier: state.widget.activeAction.identifier,
            card: state.widget.cards[state.widget.activeAction.order - 1],
            title: state.widget.activeAction.title || defaultTitle,
            subTitle: state.widget.activeAction.text || defaultSubtitle,
            rockTheVoteTitle: RockTheVoteDetails.title,
            rockTheVoteDescription: RockTheVoteDetails.description,
            rockTheVoteLabel: RockTheVoteDetails.label,
            registerButtonText:
                state.widget.activeAction.customButtonText || defaultButton,
            showAddressPopup: state.findPollingStation.showAddressPopup,
            findPollingStationError: state.findPollingStation.findPollingStationError
        };
    },
    {
        onBackWithinCard,
        onShowAddressPopup,
        setOverlayPartnerVisible
    }
)(FindPollingStationDetails);
